var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 120,
    viewBox: "0 0 166 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.356 1L47.5098 59.8463L106.356 118.693L165.202 59.8463L106.356 1ZM97.2182 74.7079V61.4716H107.854L115.919 73.2177C116.834 74.5618 117.292 75.4092 117.292 75.7598C117.292 76.3052 116.795 76.6559 115.802 76.8117V77.7467H130.236V76.8117C129.32 76.7533 128.541 76.4513 127.898 75.9059C127.275 75.341 126.282 74.0943 124.918 72.1658L117.175 61.1502C124.402 60.0398 128.015 56.2316 128.015 49.7254C128.015 47.8164 127.655 46.0243 126.934 44.3491C126.175 42.6154 125.025 41.2421 123.486 40.2292C122.162 39.3526 120.603 38.739 118.811 38.3883C117.039 38.0377 114.633 37.8624 111.594 37.8624H86.6408V38.7974C87.3421 38.9922 87.8291 39.2454 88.1018 39.5571C88.3745 39.8688 88.5109 40.3266 88.5109 40.9304V74.7079C88.5109 75.2923 88.3745 75.7403 88.1018 76.052C87.8291 76.3637 87.3421 76.6169 86.6408 76.8117V77.7467H99.0883V76.8117C98.4065 76.6364 97.9195 76.3929 97.6273 76.0812C97.3546 75.7501 97.2182 75.2923 97.2182 74.7079ZM110.659 54.8972H97.2182V44.4367H110.659C112.685 44.4367 114.087 44.4952 114.867 44.612C115.665 44.7094 116.415 44.9529 117.117 45.3425C118.597 46.1412 119.337 47.5827 119.337 49.667C119.337 51.7513 118.597 53.1928 117.117 53.9914C116.435 54.3615 115.685 54.605 114.867 54.7219C114.049 54.8388 112.646 54.8972 110.659 54.8972Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8149 116.211L76.8149 96.2114",
    stroke: "white",
    strokeWidth: 9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6113 103.008L63.6113 83.0078",
    stroke: "white",
    strokeWidth: 9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4072 89.8041L50.4072 69.8041",
    stroke: "white",
    strokeWidth: 9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 63.3967L63.397 3.99976",
    stroke: "white",
    strokeWidth: 9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2036 76.6003L76.6006 17.2034",
    stroke: "white",
    strokeWidth: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.aaf6b01046066d118b07f610f680779d.svg";
export { ForwardRef as ReactComponent };